import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-slate-400" data-testid="route-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-white/15 border-t-[var(--teal)]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
